import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { filterBreadsByCategory, filterBreadsByPage } from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType } from 'types/stock'

const useHandleKeyword = (
  breads: BreadType[],
  categories: CategoryType[],
  categoryName: string,
  setKeyword: Dispatch<SetStateAction<string>>,
  setBreadList: Dispatch<SetStateAction<BreadType[]>>,
  page: 'released' | 'unreleased',
  stocks: StockType[]
) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      // 空白であればカテゴリーのみのフィルタリング
      if (value === '') {
        const filteredBreadsByPage = filterBreadsByPage(page, breads, stocks)
        const filteredBreadsByCategory = filterBreadsByCategory(categoryName, categories, filteredBreadsByPage)
        setBreadList([...filteredBreadsByCategory])
      }
      setKeyword(value)
    },
    [categoryName, categories, breads, setKeyword, setBreadList, page, stocks]
  )
}

export default useHandleKeyword
